export const REVIEWS_NAMES = [
	'Ava Carter',
	'Liam Brooks',
	'Maya Chen',
	'Oliver Reed'
];
